import React, { useEffect, useState } from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { useTranslation } from "react-i18next"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons"

const CountdownBlock = ({ block }) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTime())
    }, 1000)
    return () => clearTimeout(timer)
  })

  // safari needs the date to be in the format of MM/DD/YYYY hh:mm
  const formatDate = (date) => {
    const fullDate = date?.split(" ")[0]
    const time = date?.split(" ")[1]
    const formatted = fullDate?.split("-")
    const year = formatted && formatted[0]
    const month = formatted && formatted[1]
    const day = formatted && formatted[2]
    return new Date(`${month}/${day}/${year} ${time}`)
  }

  const calculateTime = () => {
    const difference = formatDate(block.date) - new Date()
    let timeLeft = {}
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }
    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTime())

  return (
    <BlockWrapper block={block} blockWidth="container">
      <div className="bg-primary-600 rounded-xl">
        <div className="flex flex-row flex-wrap justify-between">
          <div className="flex flex-col flex-wrap py-4 px-grid">
            {block.kicker?.length > 0 && (
              <span className="block mb-2 text-blue-300 kicker-h3">
                {block.kicker}
              </span>
            )}
            {block.title?.length > 0 && (
              <span className="block mb-2 text-white headline-h3">
                {block.title}
              </span>
            )}
            {block.subtitle?.length > 0 && (
              <span className="block text-primary-100 subheadline-h3">
                {block.subtitle}
              </span>
            )}
          </div>
          <div className="px-grid ">
            <div className="flex flex-col flex-wrap text-white lg:flex-row -mx-grid">
              <div className="flex flex-col flex-wrap py-4 px-grid">
                {block.date?.length > 0 && (
                  <>
                    <span className="block w-full lg:text-center">
                      {block.countdown_intro}
                    </span>
                    <div className="flex flex-row w-full -mx-2 lg:mx-0 lg:text-center lg:justify-center">
                      <div className="px-2">
                        <span className="inline-block w-16 px-4 py-1 mt-2 text-2xl leading-8 text-center bg-white text-primary rounded-xl">
                          {timeLeft.days}
                        </span>
                        <span className="block mt-1">
                          {t("countdown.days")}
                        </span>
                      </div>
                      <div className="px-2">
                        <span className="inline-block w-16 px-4 py-1 mt-2 text-2xl leading-8 text-center bg-white text-primary rounded-xl">
                          {timeLeft.hours}
                        </span>
                        <span className="block mt-1">
                          {t("countdown.hours")}
                        </span>
                      </div>
                      <div className="px-2">
                        <span className="inline-block w-16 px-4 py-1 mt-2 text-2xl leading-8 text-center bg-white text-primary rounded-xl">
                          {timeLeft.minutes}
                        </span>
                        <span className="block mt-1">
                          {t("countdown.minutes")}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="flex items-center py-4 px-grid">
                {block.link_text?.length > 0 && (
                  <Link className="py-1 btn btn-primary" link={block.link}>
                    {block.link_text}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      size="1x"
                      className="ml-2"
                    />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default CountdownBlock
